import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import { modalUnavailableStore } from './store';

const { Modal, Button, Flex, Text } = Common;

const ModalUnavailable = () => {
  const {
    visible,
    hide: onCancel,
  } = modalUnavailableStore((s) => s);
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      title={null}
      centered
      noBorder
      footer={[
        <Flex
          key="footer-ok"
          align="center"
          justify="center"
          p="20px"
        >
          <Button
            type="primary"
            width="200px"
            py="12.5px"
            style={{ borderRadius: 4 }}
            onClick={onCancel}
          >
            Oke
          </Button>
        </Flex>,
      ]}
      width={500}
      height={366}
    >
      <Flex
        direction="column"
        align="center"
        justify="center"
        p="64px 0 0 0"
      >
        <Image
          width="160"
          height="120"
          src="icon/fr/fr-blocker-unavailable.svg"
        />
        <Text
          size="16px"
          weight="bold"
          align="center"
          mt="16px"
        >
          FR Bonds Tidak Tersedia
        </Text>
        <Text mt="12px" align="center">
          Produk FR Bonds tidak bisa ditransaksikan di virtual trading.
        </Text>
      </Flex>
    </Modal>
  );
};

export default ModalUnavailable;
